import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoffee = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 9h13v4a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9Z",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 10h2.2a2.3 2.3 0 0 1 0 4.6H17",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 3.5c-.6.8-.6 1.7 0 2.5M11 3.5c-.6.8-.6 1.7 0 2.5",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 20h15",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCoffee);
export default ForwardRef;
